import styled from 'styled-components';

export const FormLabel = styled.label`
    font-weight: 400;
    font-size: var(--text-size-default);
    margin: 0 4px 0 0;

    display: flex;
    justify-content: space-between;
    color: var(--form-control-label);
`;
